export enum ParamsFormOptions {
    ZONES = 'zones',
    LINES = 'line',
    VEHICLE_GROUPS = 'vehicleGroup',
    DAYS_OF_WEAK = 'daysOfWeek',
    HOURS_RANGE = 'hoursRange',
    VEHICLES_SIDE_NUMBERS = 'vehiclesSideNumbers'
}
